import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_footprint_events_groupedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { status_ids?: number[], type_ids?: number[], days_created?: number, type_name?: string }): 
  Promise<{ result: { Count?: number, MinId?: number, MaxId?: number, TypeId?: number, StatusId?: number, FootPrintEventType?: { Name?: string }, FootPrintEventStatus?: { Name?: string }, MaxEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string }, MinEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { status_ids?: number[], type_ids?: number[], days_created?: number, type_name?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Count?: number, MinId?: number, MaxId?: number, TypeId?: number, StatusId?: number, FootPrintEventType?: { Name?: string }, FootPrintEventStatus?: { Name?: string }, MaxEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string }, MinEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { status_ids?: number[], type_ids?: number[], days_created?: number, type_name?: string, $keys: { TypeId?: number, StatusId?: number, FootPrintEventType?: { Name?: string }, FootPrintEventStatus?: { Name?: string } }[] }): 
  Promise<{ result: { Count?: number, MinId?: number, MaxId?: number, TypeId?: number, StatusId?: number, FootPrintEventType?: { Name?: string }, FootPrintEventStatus?: { Name?: string }, MaxEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string }, MinEvent?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      status_ids?: number[], type_ids?: number[], days_created?: number, type_name?: string    }) {
      return false;
    }
}
